export default __webpack_public_path__ + "static/media/portfolio.9de88505.png";